<template>
    <div @click.stop class="map-btn-menu map-shadow map-top-item">
        <div class="menu-title">
        {{ title }}
        <v-icon class="menu-close" color="white" @click="$emit('close')">icon-close</v-icon>
        </div>

        <template v-if="!options_length">
        <div class="menu-list">
            <label>
            <span>
                <slot name="empty-msg">--- 無可調整項目 ---</slot>
            </span>
            </label>
        </div>
        </template>

        <template v-else-if="input_type == 'basemap_boundary'">
        <div class="menu-list" v-for="(option_item, option_item_key) in option_data" :key="option_item_key">
            <div class="menu-list__subtitle d-flex aligh-center">
            <v-icon color="white">{{option_item.subtitle.icon == 'basemap' ? 'icon-selected-data-setting-2' : 'icon-geographic-info'}}</v-icon>
            {{option_item.subtitle.name}}
            </div>
            <label class="menu-list__label" v-for="(options, key) in option_item.list" :key="key">
            <template v-if="option_item_key == 0">
                <input
                :value="options.name"
                :name="name"
                v-model="selected[0]"
                @change="$emit('change_boundary', selected[0], options.name, $event.target.checked)"
                type="checkbox"
                />
                <div 
                :class="[
                    { checked:  selected[0].includes(options.name) }, 
                    'checkbox'
                ]">
                </div>
            </template>
            <template v-else>
                <input
                :value="options.name"
                :name="name"
                v-model="selected[1]"
                @change="$emit('change_basemap', selected[1])"
                type="radio"
                />
                <div 
                :class="[
                    { checked:  selected[1] === options.name }, 
                    'radio'
                ]">
                </div>
            </template>
            <span>{{ options.text }}</span>
            </label>
        </div>
        </template>

        <template v-else-if="input_type == 'radio'">
            <div class="menu-list">
                <label v-for="(options, key) in option_data" :key="key">
                <input
                    :value="options.name"
                    :name="name"
                    v-model="selected"
                    @change="$emit('change', selected)"
                    type="radio"
                />
                <span>{{ options.text }}</span>
                </label>
            </div>
        </template>

        <template v-else-if="input_type == 'checkbox'">
            <div class="menu-list">
                <label v-for="(options, key) in option_data" :key="key">
                <input
                    :value="options.name"
                    :name="name"
                    v-model="selected"
                    @change="$emit('change', selected, options.name, $event.target.checked)"
                    type="checkbox"
                />
                <span>{{ options.text }}</span>
                </label>
            </div>
        </template>

        <template v-else-if="input_type == 'dragable'">
            <draggable
                v-model="option_data"
                @change="$emit('change', options_name_list, $event.moved)"
                class="menu-list draggable-list"
            >
                <label
                    v-for="(options, key) in option_data"
                    :key="key"
                    :title="'上下拖動可調整圖層順序'"
                    @click.stop
                >
                    <span>
                        {{ options.text }}
                        <span class="menu-order">{{ key + 1 }}</span>
                    </span>
                </label>
            </draggable>
        </template>

        <template v-else-if="input_type == 'range'">
        <div class="menu-list">
            <label v-for="(options, key) in option_data" :key="key">
            <span>
                {{ options.text }}
                <span class="menu-range">
                    <input
                        v-model="values[options.name]"
                        name="name"
                        @change="$emit('change', options.name, $event.target.value)"
                        type="range"
                        min="0"
                        max="1"
                        step="0.1"
                    />
                    <span :style="{ opacity: values[options.name] }">
                        {{ values[options.name] * 100 }}%
                    </span>
                </span>
            </span>
            </label>
        </div>
        </template>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    export default {
        name: 'btn-menu',

            components: {
                draggable
            },

        props: ['input_type', 'name', 'title', 'data', 'default_val', 'set_val'],
        
        data: function() {
            return {
                option_data: [],
                selected: [],
                values: this.set_val
            }
        },
        
        computed: {
            options_length() {
                return Object.entries(this.option_data).length
            },
            options_name_list() {
                return $.map(this.option_data, o => {
                    return o.name
                })
            }
        },
        
        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    this.option_data = this.data
                }
            },
            default_val: {
                immediate: true,
                handler() {
                    this.selected = this.default_val 
                }
            }
        },
    }
</script>

<style lang="scss">
:root {
    --btn-menu-font-family: var(--font-family);
    --btn-menu-main-color: #ffffff;
    --btn-menu-text-color: #b3b7c4;
    --btn-menu-background-color: #454d66;
    --btn-menu-hover-color: #319da9;
    --btn-menu-hover-text-color: #ffffff;
}

/*btn menu*/
.map-btn-menu {
    position: absolute;
    right: 3rem;
    border-radius: 8px;
    overflow-x: hidden;
    font-family: var(--btn-menu-font-family);
    font-size: 1em;
    background: var(--btn-menu-background-color);
}

.map-btn-menu::before {
    content: '';
    position: absolute;
    height: 0;
    border: 0.4em solid transparent;
    border-left: 0;
    border-right: 0.5em solid #fff;
    left: -0.6em;
    top: 0;
    bottom: 0;
    margin: auto;
    opacity: 0.5;
}

.map-btn-menu .menu-title {
    position: relative;
    padding: 10px 0;
    min-width: 224px;
    font-size: 0.875em;
    text-align: center;
    color: var(--btn-menu-main-color);
    background: var(--base-dark-blue);
}

.map-btn-menu .menu-close {
    position: absolute;
    right: 0.3em;
    top: 8px;
    right: 8px;
}

.map-btn-menu .menu-close:hover {
    color: var(--btn-menu-hover-color);
}

.map-btn-menu .menu-list label:last-child {
    border-bottom: none;
}
.menu-list label:hover {
    color: var(--btn-menu-hover-text-color);
    background-color: var(--btn-menu-hover-color);
}

/*range menu list*/
.menu-list .menu-range {
    margin-left: 1em;
}

.menu-list .menu-range > span {
    display: inline-block;
    width: 3.5em;
    padding: 0.2em 0;
    color: #fff;
    background-color: var(--btn-menu-main-color);
    border-radius: 0.2em;
    text-align: center;
}
.menu-list .menu-range input[type='range'] {
     width: 7em;
}

/*draggable menu list*/
.menu-list.draggable-list label {
    cursor: grab;
}

.draggable-list label.sortable-chosen {
    color: #fff;
    background-color: #ff6363;
}

.draggable-list label > span:before {
    content: '⇕';
    /* position: absolute; */
    /* left: 0.8em; */
    margin-top: -0.1em;
    color: var(--btn-menu-main-color);
    transform: scale(1.5);
}

.draggable-list .menu-order {
    width: 2em;
    padding: 0.2em 0;
    margin-left: 0.8em;
    color: #fff;
    background-color: var(--btn-menu-main-color);
    border-radius: 0.2em;
    text-align: center;
}

.menu-list {
  &__subtitle {
    padding: 8px 20px;
    background: var(--linear-gradient-color-1);
  }

  &__label {
    position: relative;
    display: flex;
    font-size: 0.875em;
    font-weight: normal;
    white-space: nowrap;
    letter-spacing: 0.6px;
    padding: 2px 12px;
    margin: 0 12px;
    border-left: 1px solid var(--base-gray-darken);
    cursor: pointer;
    align-items: center;

    input {
      display: None;
    }

    div {
      display: inline-block;
      margin-right: 0.25rem;
      &::before {
        font-family: 'fontello';
        visibility: visible;
        font-size: 24px;
      }

      &.checkbox::before {
        content: '\e81f';
      }
      &.checkbox.checked::before{
        content: '\e81e'
      }
      &.radio::before {
        content: '\e849';
      }
      &.radio.checked::before{
        content: '\e848'
      }
    }
  }
}

</style>
